import { Paginated } from 'mdello-client-ts/dist/src/interfaces/common/paging.interface';
import { HolidayType } from 'mdello-client-ts/dist/src/interfaces/providers/intranet/holiday/holiday';
import { useMemo } from 'react';
import Copy from 'src/component/Copy';
import InnerHeader from 'src/component/InnerHeader';
import NoxTable from 'src/component/Table';
import { SearchBy } from 'src/component/Table/enums/searchby.enum';
import formatDate from 'src/helpers/formatDate';
import { useQueryParams } from 'src/hooks/useQueryParams';
import { useGetHolidays } from 'src/reactQuery/requests/vacations/useGetVacationDays';
import { useDownloadVacationbBalanace } from '../../reactQuery/requests/vacations/useDownloadVacationBalanceCsvMutation';

interface RequestTableProps {
  company: string;
  fullName: string;
  holidayActualType: string;
  remainingDays: number;
  startDate: string;
  userId: string;
}

interface QueryParams extends Paginated {
  holidayType: HolidayType;
}

const VacationBalance = () => {
  const { queryParams, setQueryParams } = useQueryParams<QueryParams>();

  const { data: holidays } = useGetHolidays(queryParams.holidayType || HolidayType.HOLIDAY);

  const holidaysResponseData: RequestTableProps[] | [] = useMemo(() => {
    if (!holidays) {
      return [];
    }

    const filteredHolidays: RequestTableProps[] = holidays.map((holiday) => {
      return {
        company: holiday.company,
        fullName: holiday.user.fullName,
        holidayActualType: holiday.holidayAcrualType,
        remainingDays: holiday.remainingDays,
        startDate: holiday.startDate || '',
        userId: holiday.user._id
      };
    });

    return filteredHolidays;
  }, [holidays]);

  const columns = [
    {
      dataIndex: 'userId',
      key: 'userId',
      render: (userId: any) => {
        return <Copy text={userId} />;
      },
      sorter: (a: any, b: any) => a.userId.toString().localeCompare(b.userId),
      title: 'User Id'
    },
    {
      dataIndex: 'fullName',
      key: 'fullName',
      render: (fullName: any) => {
        return <Copy text={fullName} />;
      },
      sorter: (a: any, b: any) => a.fullName.toString().localeCompare(b.fullName),
      title: 'Full Name'
    },
    {
      dataIndex: 'remainingDays',
      key: 'remainingDays',
      render: (remainingDays: any) => {
        return <Copy text={remainingDays} />;
      },
      sorter: (a: any, b: any) => a.remainingDays.toString().localeCompare(b.remainingDays),
      title: 'Remaining Days'
    },
    {
      dataIndex: 'startDate',
      key: 'startDate',
      render: (startDate: any) => {
        return <Copy text={formatDate(startDate)} />;
      },
      sorter: (a: any, b: any) => a.startDate.toString().localeCompare(b.startDate),
      title: 'Start Date'
    },
    {
      dataIndex: 'company',
      key: 'company',
      render: (company: any) => {
        return <Copy text={company} />;
      },
      sorter: (a: any, b: any) => a.company.localeCompare(b.company),
      title: 'Company'
    },
    {
      dataIndex: 'holidayActualType',
      key: 'holidayActualType',
      render: (holidayActualType: any) => {
        return <Copy text={holidayActualType} />;
      },
      sorter: (a: any, b: any) => a.holidayActualType.toString().localeCompare(b.holidayActualType),
      title: 'Holiday Actual Type'
    }
  ];

  const holidayTypes = Object.values(HolidayType);
  const changeFilter = (holidayType: HolidayType) => {
    setQueryParams({ ...queryParams, holidayType });
  };

  const { mutate: onDownloadCsvMutation } = useDownloadVacationbBalanace({});

  const actions = [
    {
      onClick: () => onDownloadCsvMutation(),
      title: 'Download CSV',
      type: 'primary'
    }
  ];

  return (
    <div
      style={{
        backgroundColor: 'white',
        height: 'calc(100vh - 155px)',
        overflowY: 'scroll'
      }}
    >
      <InnerHeader subtitle={holidaysResponseData?.length} title="Holidays" />
      {/* @ts-ignore */}
      <NoxTable
        actions={actions}
        checkbox={false}
        columns={columns}
        data={holidaysResponseData}
        filterList={[holidayTypes]}
        onFilterChange={changeFilter}
        searchBy={SearchBy.FULL_NAME}
        selectedFilter={[queryParams.holidayType || HolidayType.HOLIDAY]}
      />
    </div>
  );
};

export default VacationBalance;
